import { InjectionMode } from '#analytics/InjectionMode';

export function getPageData<T extends BasePageModel>(): T {
  const container = document.getElementById('main-app');
  const parsedPageData = JSON.parse(container.dataset.model) as T & { TransactionAttributes?: unknown[] };
  const transactionAttributes = Object.prototype.hasOwnProperty.call(parsedPageData, 'TransactionAttributes')
    ? { TransactionAttributes: parsedPageData.TransactionAttributes ?? [] }
    : {};
  const pageData: T = {
    ...parsedPageData,
    ...transactionAttributes,
    ApiBaseUrl: container.dataset.baseurl,
    LogoUri: (document.getElementById('logo-image-link') as HTMLLinkElement)?.href,
  };

  return { ...pageData };
}

export type BasePageModel = {
  ApiBaseUrl: string;
  LogoUri: string;
  AccountName: string;
  PublicEmailAddress: string;
  Subdomain: string;
  GoogleDataSiteClientKey: string;
  GoogleDataSiteClientKeyV3: string;
  GoogleDataSiteInvisibleClientKey: string;
  PaymentPageBannerText?: string;
  IsAuthenticated: boolean;
  MixpanelToken: string;
  InjectionMode: InjectionMode;
  DisableMixpanel: boolean;
  DisablePaymentPage: boolean;
  MixpanelProxyUrl: string;
};
